// extracted by mini-css-extract-plugin
export default {"text":"PdfButton_text__k3nEE","button":"PdfButton_button__6bNx8","pdf":"PdfButton_pdf__kcgD6","email":"PdfButton_email__5iqdp"};